import React, { forwardRef } from 'react';
import classnames from 'classnames';

import { useMergeRefs } from 'Wpds/hooks/useMergeRefs';

import './WpContainer.scss';

export type ColorType = 'white' | 'gray' | 'purple' | 'transparent';

export interface Props {
  children?: React.ReactNode;
  className?: string;
  onClick?: Function;
  containerRef?: React.Ref<HTMLDivElement>;
  role?;
  qaTest?: string;
  color?: ColorType;
  styles?: React.CSSProperties;
}

const WpContainer = forwardRef(function (
  { children, className = '', onClick, containerRef, role, qaTest, color = 'white', styles }: Props,
  ref: any
) {
  const refs = useMergeRefs([containerRef, ref]);
  const classNamePrefix = 'WpContainer';
  const classes = classnames(
    classNamePrefix,
    `${classNamePrefix}--color-${color}`,
    className,
    onClick && `${classNamePrefix}__hover`
  );

  const handleOnClick = (e: React.MouseEvent) => {
    onClick && onClick(e);
  };

  return (
    <div className={classes} onClick={handleOnClick} ref={refs} role={role} data-test={qaTest} style={styles}>
      {children}
    </div>
  );
});

export default WpContainer;
